const listStyle = {
  listStyleType: 'disc',
  paddingLeft: '1.5rem',
  marginTop: '0.5rem',
};

export const individualFAQs = [
    {
        question: "How do I launch a quest on Lunor?",
        answer: "Launching a quest is simple. All you need is your idea. Define the challenge, describe what you're aiming to achieve, and set up your prize pool using Lunor.Fund. Our platform guides you step-by-step to bring your vision to life.",
    },
    {
        question:
            "Can I launch a quest if I don't have data or a base model?",
        answer: "Absolutely! Lunor.Quest is designed to support individuals at any stage of their AI journey. You can start with just an idea, and the community will help with data collection, model creation, or solution refinement.",
    },
    {
        question: "Can I crowdfund a prize pool for my quest?",
        answer: "Yes! With Lunor.Fund, you can crowdfund resources for your prize pool, allowing others who share your vision to contribute and support your quest.",
    },
    {
        question: "What kind of challenges can I host as an individual?",
        answer: (
            <div>
                You can host challenges related to any step of the AI
                pipeline, including:
                <ul style={listStyle}>
                    <li>Data collection</li>
                    <li>Model creation</li>
                    <li>Solution evaluation</li>
                </ul>
                Whether it's a social cause, a startup idea, or a personal
                innovation, Lunor.Quest supports your goals.
            </div>
        ),
    },
    {
        question: "How are submissions evaluated?",
        answer: "You can choose to have submissions peer-reviewed by the Lunor community or reviewed by experts. This ensures you get high-quality solutions tailored to your needs.",
    },
    {
        question: "Who owns the solutions developed in my quest?",
        answer: "As a host, you can define what happens to the solutions created during the quest. You can choose to open-source solutions, share co-ownership with contributors, or retain full ownership. This flexibility allows you to structure your quest based on your preferences.",
    },
    {
        question:
            "How do participants get rewarded for their contributions?",
        answer: "Participants receive rewards based on the prize pool and the success of their submissions. The rewards are distributed according to the terms set when you launch the quest.",
    },
    {
        question: "What kind of support does Lunor offer for individuals?",
        answer: (
            <div>
                Lunor provides tools to:
                <ul style={listStyle}>
                    <li>Help you define and launch your quest.</li>
                    <li>Crowdfund prize pools using Lunor.Fund.</li>
                    <li>
                        Connect with global experts and manage collaboration
                        effectively.
                    </li>
                </ul>
            </div>
        ),
    },
    {
        question: "What if I'm new to AI or data science?",
        answer: "No problem! You don't need to be an AI expert. Lunor.Quest supports individuals from all backgrounds. Our platform and community are designed to help you turn your ideas into actionable solutions. However, having domain expertise in the problem you're trying to solve is highly encouraged, and we recommend partnering with a co-host who has AI expertise to guide the technical aspects of your quest.",
    },
    {
        question: "Can I start small and grow my project over time?",
        answer: "Yes, Lunor.Quest allows you to start with a simple challenge and expand over time. Whether it's collecting initial data or refining solutions, you can grow your project at your own pace.",
    },
    {
        question: "What happens to solutions created during the Quest?",
        answer: (
            <div>
                The fate of the solutions depends on the ownership structure
                defined by the host.
                <ul style={listStyle}>
                    <li>
                        <strong>Multiple Owners:</strong> The solution can
                        be published on lunor.market, where it is accessible
                        through subscriptions. Any revenue generated is
                        shared among the owners.
                    </li>
                    <li>
                        <strong>Single Owner:</strong> The owner can choose
                        to list the solution on lunor.market for
                        monetization or keep it private for exclusive use.
                    </li>
                </ul>
            </div>
        ),
    },
]